import { DecimalPipe } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { Utility } from 'src/app/core/common';
import { JobService } from 'src/app/services/job.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-job-summary',
  templateUrl: './job-summary.component.html',
  styleUrls: ['./job-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JobSummaryComponent implements OnInit {
  Utility = Utility;
  @Input() mode: 'simple' | '' = '';
  @Input() job: any;
  @Input() selected: boolean;
  @Input('advertise-id') advertiseId: string;
  @Input() showFavorite = true;
  @Input() hideDateAndStatus = false;
  @Input() favorite: boolean;
  @Input() newDate?: Date;
  @Input() disableLink: boolean;
  @Output('job-click') jobClick = new EventEmitter<string>();
  @Output() toggleFavorite = new EventEmitter();

  constructor(private jobService: JobService, public sharedService: SharedService) { }

  fields: any[];
  ngOnInit(): void {
    this.fields = this.jobService.getJobSummaryFields(this.job);
  }

  @Input() collect = true;
  get isNew(): boolean {
    return this.newDate && this.newDate < new Date(this.job.StartTime);
  };

  get title() {
    return (this.job.HighlightedTitle || 'آگهی استخدام') + (this.job._duplicate && this.job.HighlightedCompany ? ' در ' + this.job.HighlightedCompany : '');
  }

  async setFavorite(job: any | string, e?: MouseEvent) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      e = undefined;
    }
    this.toggleFavorite.emit();
  }


}
